import { Permission, alphabeticalSort, notEqual } from '@cims-online/shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  Discipline,
  useDisciplinesTableContext,
} from '../../../../DisciplinesTableContext'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { useEditDsDisciplineMutation } from 'schema'
import { useUserSelectContext } from 'components/CIMSSelect/common/UserSelect/UserSelectContext'
import { CreateEditFormItems } from '../../components/CreateEditFormItems'
import { CreateEditFormItemValues } from '../../components/CreateEditFormItems/types'

export function useEdit(): EditRowActionOptions<
  Discipline,
  CreateEditFormItemValues
> {
  const { refetch } = useDisciplinesTableContext()
  const { toLabeledValues, fromLabeledValues } = useUserSelectContext()
  const [edit] = useEditDsDisciplineMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editDSDiscipline: {
        discipline: { name },
      },
    }) => simpleEditNotification(name),
  })
  return {
    permission: Permission.EditDesignSubmittalDiscipline,
    modal: {
      type: 'simple',
      recordName: 'name',
      body: <CreateEditFormItems />,
      initialValues: ({ name, description, users }) => {
        return {
          name,
          description: description,
          users: toLabeledValues(users).sort(alphabeticalSort('label')),
        }
      },
      onOk: async (
        { id, name: prevName, description: prevDescription, users: prevUsers },
        { name, description, users }: CreateEditFormItemValues
      ) => {
        const prevUserIds = prevUsers.map(({ id }) => id)
        const userIds = fromLabeledValues(users)
        if (
          prevName !== name ||
          prevDescription !== description ||
          notEqual(prevUserIds, userIds)
        ) {
          await edit({
            variables: {
              editDsDisciplineInput: {
                id,
                description,
                name,
                userIds,
              },
            },
          })
          await refetch()
        }
      },
    },
  }
}
